import { render, staticRenderFns } from "./myFaceInfo.vue?vue&type=template&id=731d1c75&scoped=true&"
import script from "./myFaceInfo.vue?vue&type=script&lang=js&"
export * from "./myFaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./myFaceInfo.vue?vue&type=style&index=0&id=731d1c75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d1c75",
  null
  
)

export default component.exports